/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LabelPermissions } from './labelPermissions';


export interface LabelDetailDto { 
    id: string;
    shortcut: string;
    name: string;
    description: string;
    isVisible: boolean;
    color: string;
    dimension: LabelDetailDto.DimensionEnum;
    category: LabelDetailDto.CategoryEnum;
    permissions: LabelPermissions;
}
export namespace LabelDetailDto {
    export type DimensionEnum = 'TEMPERATURE' | 'ENERGY' | 'POWER' | 'VOLUME' | 'VOLUME_FLOW' | 'PRESSURE' | 'FRACTION' | 'VOLTAGE' | 'CURRENT' | 'FREQUENCY' | 'NONE';
    export const DimensionEnum = {
        Temperature: 'TEMPERATURE' as DimensionEnum,
        Energy: 'ENERGY' as DimensionEnum,
        Power: 'POWER' as DimensionEnum,
        Volume: 'VOLUME' as DimensionEnum,
        VolumeFlow: 'VOLUME_FLOW' as DimensionEnum,
        Pressure: 'PRESSURE' as DimensionEnum,
        Fraction: 'FRACTION' as DimensionEnum,
        Voltage: 'VOLTAGE' as DimensionEnum,
        Current: 'CURRENT' as DimensionEnum,
        Frequency: 'FREQUENCY' as DimensionEnum,
        None: 'NONE' as DimensionEnum
    };
    export type CategoryEnum = 'NONE' | 'HEAT' | 'COLD_WATER' | 'GENERAL_ELECTRICITY' | 'SOLAR';
    export const CategoryEnum = {
        None: 'NONE' as CategoryEnum,
        Heat: 'HEAT' as CategoryEnum,
        ColdWater: 'COLD_WATER' as CategoryEnum,
        GeneralElectricity: 'GENERAL_ELECTRICITY' as CategoryEnum,
        Solar: 'SOLAR' as CategoryEnum
    };
}


